// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GYM63{background-color:#fff;border:none;border-radius:12px;padding:32px;padding:2rem;margin-top:16px;margin-top:1rem;-webkit-box-shadow:none;box-shadow:none}
.Ho1V6{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:24px;gap:1.5rem}
.eti80{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px;gap:1rem;padding:24px;padding:1.5rem;background-color:#f0fdf4;border-radius:8px;border:1px solid #bbf7d0}
.be_hD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;gap:.75rem;font-size:18px;color:#065f46}
.J_eU4{font-family:"Inter",sans-serif;font-weight:400}
.ZpY7K{color:#10b981;-ms-flex-negative:0;flex-shrink:0}
.bWojM{color:#d97706;-ms-flex-negative:0;flex-shrink:0}
.MeTRB{text-align:center;padding:16px;padding:1rem;background-color:#f8fafc;border-radius:8px;border:1px solid #e2e8f0}
.AA9ji{color:#374151;font-size:18px;font-weight:400;line-height:1.5;margin-bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authorizationContainer": `GYM63`,
	"authorizationContent": `Ho1V6`,
	"statusList": `eti80`,
	"statusItem": `be_hD`,
	"statusText": `J_eU4`,
	"checkIcon": `ZpY7K`,
	"clockIcon": `bWojM`,
	"infoMessage": `MeTRB`,
	"infoDescription": `AA9ji`
};
module.exports = ___CSS_LOADER_EXPORT___;
